// extracted by mini-css-extract-plugin
module.exports = {"content":"Breadcrumb__content___Zu7Jo","item":"Breadcrumb__item___FBM3m"};